import { produce } from "immer";
import {
  FETCH_LOCATION_BLOGS,
  FETCH_LOCATION_BLOGS_SUCCESS,
  FETCH_LOCATION_BLOGS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_LOCATION_BLOGS,
  ADD_LOCATION_BLOGS_SUCCESS,
  ADD_LOCATION_BLOGS_FAILURE,
  //
  EDIT_LOCATION_BLOGS,
  EDIT_LOCATION_BLOGS_SUCCESS,
  EDIT_LOCATION_BLOGS_FAILURE,
  //
  DELETE_LOCATION_BLOGS,
  DELETE_LOCATION_BLOGS_SUCCESS,
  DELETE_LOCATION_BLOGS_FAILURE,
  //
  OPEN_BLOG_ADD_MODAL,
  CLOSE_BLOG_ADD_MODAL,
  //
  OPEN_BLOG_EDIT_MODAL,
  CLOSE_BLOG_EDIT_MODAL,
  //
  SET_BLOG_SUCCESS,
  SET_BLOG_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingLocationBlogs: false,
  LocationBlogs: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentLocationBlogs: {},
  // Delete
  isDeleting: false,
  isBlogAddModalOpen: false,
  isBlogEditModalOpen: false,
};

const LocationBlogsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_LOCATION_BLOGS:
        draft.isFetchingLocationBlogs = true;
        draft.currentLocationBlogs = {};
        break;
      case FETCH_LOCATION_BLOGS_SUCCESS:
        draft.isFetchingLocationBlogs = false;
        draft.LocationBlogs = action.payload;
        break;
      case FETCH_LOCATION_BLOGS_FAILURE:
        draft.isFetchingLocationBlogs = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentLocationBlogs = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentLocationBlogs = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_LOCATION_BLOGS:
        draft.isSubmitting = true;
        break;
      case ADD_LOCATION_BLOGS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_LOCATION_BLOGS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_LOCATION_BLOGS:
        draft.isSubmitting = true;
        break;
      case EDIT_LOCATION_BLOGS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_LOCATION_BLOGS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_LOCATION_BLOGS:
        draft.isDeleting = true;
        break;
      case DELETE_LOCATION_BLOGS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_LOCATION_BLOGS_FAILURE:
        draft.isDeleting = false;
        break;
      case OPEN_BLOG_ADD_MODAL:
        draft.isBlogAddModalOpen = true;
        draft.isBlogEditModalOpen = false;
        break;
      case CLOSE_BLOG_ADD_MODAL:
        draft.isBlogAddModalOpen = false;
        break;
      case OPEN_BLOG_EDIT_MODAL:
        draft.currentLocationBlogs = {};
        draft.isBlogEditModalOpen = true;
        draft.isFetching = true;
        draft.isBlogAddModalOpen = false;
        break;
      case CLOSE_BLOG_EDIT_MODAL:
        draft.isBlogEditModalOpen = false;
        draft.currentLocationBlogs = {};
        break;
      case SET_BLOG_SUCCESS:
        draft.isFetching = false;
        draft.currentLocationBlogs = action.payload;
        break;
      case SET_BLOG_FAILURE:
        draft.isFetching = false;
        draft.currentLocationBlogs = {};
        break;

      default:
        return state;
    }
  });

export default LocationBlogsReducer;
